export default __webpack_public_path__ + "static/media/Logo_REST.c5618b6d.png";